"use client";
import { useEffect, useRef } from "react";
const stack = [];
let listening = false;
function onKey(event) {
    if (event.key !== "Escape" || stack.length === 0)
        return;
    event.preventDefault();
    event.stopImmediatePropagation();
    stack[stack.length - 1].close();
}
function push(layer) {
    stack.push(layer);
    if (!listening && typeof document !== "undefined") {
        document.addEventListener("keydown", onKey, true);
        listening = true;
    }
}
function remove(layer) {
    const index = stack.indexOf(layer);
    if (index >= 0)
        stack.splice(index, 1);
    if (stack.length === 0 && listening) {
        document.removeEventListener("keydown", onKey, true);
        listening = false;
    }
}
/** While `active`, Esc calls `onEscape` — only when this is the topmost open layer. */
export function useEscapeLayer(active, onEscape) {
    const handler = useRef(onEscape);
    handler.current = onEscape;
    useEffect(() => {
        if (!active)
            return;
        const layer = { close: () => handler.current() };
        push(layer);
        return () => remove(layer);
    }, [active]);
}
/** Open layers right now: code outside React that also handles Esc (a host's document listener) yields while one is open. */
export function openLayerCount() {
    return stack.length;
}
